(function () {
  var SECTION     = window.__mbPDP.sectionId;
  var variants    = window.__mbPDP.variants;
  var productImgs = window.__mbPDP.imgIds;

  /* ── Selected options tracking ── */
  var selectedOptions = (window.__mbPDP && window.__mbPDP.selectedOptions) ? window.__mbPDP.selectedOptions.slice() : [];

  /* ── Size: nothing preselected unless the link carried ?variant= ── */
  var SIZE_IDX = (typeof window.__mbPDP.sizeIndex === 'number') ? window.__mbPDP.sizeIndex : -1;
  if (SIZE_IDX >= 0 && !window.__mbPDP.sizePreselected) selectedOptions[SIZE_IDX] = null;
  var sizeError = document.getElementById('mb-size-error-' + SECTION);
  var sizesBox  = SIZE_IDX >= 0 ? document.getElementById('mb-sizes-' + SECTION + '-' + SIZE_IDX) : null;
  function sizeMissing() { return SIZE_IDX >= 0 && !selectedOptions[SIZE_IDX]; }
  function clearSizeError() {
    if (sizeError) sizeError.hidden = true;
    if (sizesBox) sizesBox.classList.remove('is-invalid');
  }
  function showSizeError() {
    if (sizeError) sizeError.hidden = false;
    if (sizesBox) {
      sizesBox.classList.add('is-invalid');
      sizesBox.classList.remove('shake');
      void sizesBox.offsetWidth;
      sizesBox.classList.add('shake');
      setTimeout(function(){ sizesBox.classList.remove('shake'); }, 450);
    }
  }

  /* ── Gallery ── */
  var thumbs   = document.querySelectorAll('#mb-gallery-' + SECTION + ' .mb-thumb');
  var mainImgs = document.querySelectorAll('#mb-gallery-' + SECTION + ' .mb-gallery-img');

  function setImage(idx) {
    thumbs.forEach(function(t){ t.classList.toggle('is-active', +t.dataset.index === idx); });
    mainImgs.forEach(function(img){ img.classList.toggle('is-hidden', +img.dataset.index !== idx); });
  }
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){ setImage(+t.dataset.index); });
  });

  /* ── Variant lookup ── */
  function findVariant(opts) {
    return variants.find(function(v){
      return v.options.every(function(o, i){ return o === opts[i]; });
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function updateVariant() {
    if (sizeMissing()) return;
    var v = findVariant(selectedOptions);
    if (!v) return;

    /* Hidden input */
    var inp = document.getElementById('mb-variant-id-' + SECTION);
    if (inp) inp.value = v.id;

    /* Price */
    var priceEl = document.getElementById('mb-price-' + SECTION);
    if (priceEl) {
      var html = '';
      if (v.compare_at_price > v.price) {
        html += '<span class="compare">' + formatMoney(v.compare_at_price) + '</span><span class="dot"></span><span class="sale">' + formatMoney(v.price) + '</span>';
      } else {
        html += '<span>' + formatMoney(v.price) + '</span>';
      }
      priceEl.innerHTML = html;
    }

    /* ATB button text */
    var atb = document.getElementById('mb-atb-' + SECTION);
    if (atb) {
      if (!v.available) {
        atb.textContent = 'Sold Out';
        atb.disabled = true;
      } else {
        atb.textContent = 'Add to Cart';
        atb.disabled = false;
      }
    }

    /* Switch gallery to variant image */
    if (v.featured_image) {
      var imgIdx = productImgs.indexOf(v.featured_image.id);
      if (imgIdx >= 0) setImage(imgIdx);
    }
  }

  /* ── Option buttons ── */
  document.querySelectorAll('[data-option-index]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var idx = +btn.dataset.optionIndex;
      var val = btn.dataset.value;
      selectedOptions[idx] = val;

      /* Update active state */
      document.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function(b){
        b.classList.toggle('is-active', b.dataset.value === val);
      });

      /* Update label */
      var labelEl = document.getElementById('mb-size-label-' + SECTION);
      if (labelEl) labelEl.textContent = val;

      if (idx === SIZE_IDX) clearSizeError();
      updateVariant();
    });
  });

  /* ── Add to cart ── */
  var atbBtn   = document.getElementById('mb-atb-' + SECTION);
  var toast    = document.getElementById('mb-pdp-toast-' + SECTION);
  var toastMsg = document.getElementById('mb-pdp-toast-msg-' + SECTION);

  function showToast(msg) {
    toastMsg.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function(){ toast.classList.remove('show'); }, 2800);
  }

  if (atbBtn) {
    atbBtn.addEventListener('click', function(e){
      e.preventDefault();
      if (atbBtn.disabled) return;

      /* No size chosen: block and explain */
      if (sizeMissing()) {
        showSizeError();
        return;
      }

      var variantId = document.getElementById('mb-variant-id-' + SECTION).value;

      atbBtn.classList.add('is-adding');
      atbBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        atbBtn.classList.remove('is-adding');
        atbBtn.classList.add('is-added');
        atbBtn.textContent = '✓ Added';
        setTimeout(function(){
          atbBtn.classList.remove('is-added');
          atbBtn.textContent = 'Add to Cart';
        }, 2200);
        showToast('Added to bag');
        /* Refresh cart count */
        fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
          var c = document.querySelector('.mb-cart-count, [data-cart-count]');
          if (c) c.textContent = cart.item_count;
          var drawerBtn = document.querySelector('[data-mb-open-cart]');
          if (drawerBtn) drawerBtn.click();
        });
      })
      .catch(function(){
        atbBtn.classList.remove('is-adding');
        atbBtn.textContent = 'Add to Cart';
        showToast('Something went wrong — please try again');
      });
    });
  }

  /* Block native form submit (Enter key) without a size */
  var pdpForm = document.querySelector('form[id^="mb-pdp-form"]');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function(e){
      if (sizeMissing()) { e.preventDefault(); showSizeError(); }
    });
  }

  /* ── Accordions ── */
  document.querySelectorAll('.mb-acc-head').forEach(function(head){
    head.addEventListener('click', function(){
      var item = head.closest('.mb-acc-item');
      var body = item.querySelector('.mb-acc-body');
      var isOpen = item.classList.contains('open');
      /* Close all */
      document.querySelectorAll('.mb-acc-item.open').forEach(function(o){
        o.classList.remove('open');
        o.querySelector('.mb-acc-body').style.maxHeight = null;
        o.querySelector('.mb-acc-head').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
        head.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Wishlist ── connected to localStorage via mbWishlistToggle ── */
  var wishBtn = document.getElementById('mb-wish-' + SECTION);
  if (wishBtn) {
    /* Set initial state from localStorage */
    function syncWishBtn() {
      var WL_KEY = 'mb_wishlist';
      var productId = wishBtn.dataset.wlId;
      try {
        var list = JSON.parse(localStorage.getItem(WL_KEY)) || [];
        var saved = list.some(function(i){ return String(i.id) === String(productId); });
        wishBtn.classList.toggle('is-saved', saved);
        wishBtn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
      } catch(e) {}
    }
    syncWishBtn();

    wishBtn.addEventListener('click', function(){
      var item = {
        id: wishBtn.dataset.wlId,
        title: wishBtn.dataset.wlTitle,
        price: parseInt(wishBtn.dataset.wlPrice),
        image: wishBtn.dataset.wlImage,
        url: wishBtn.dataset.wlUrl,
        variant_id: wishBtn.dataset.wlVariantId,
        variant_title: wishBtn.dataset.wlVariantTitle
      };
      if (window.mbWishlistToggle) {
        window.mbWishlistToggle(item);
        syncWishBtn();
        var saved = wishBtn.classList.contains('is-saved');
        /* Open wishlist drawer when adding; do nothing on remove */
        if (saved && window.mbOpenWishlist) {
          setTimeout(function(){ window.mbOpenWishlist(); }, 150);
        }
      } else {
        /* Fallback if drawer JS not loaded yet */
        wishBtn.classList.toggle('is-saved');
      }
    });
  }

  /* Re-hide Globo elements after size selection (Globo re-renders on variant change) */
  function hideGloboElements() {
    var form = document.querySelector('form[id^="mb-pdp-form"]');
    if (!form) return;
    form.querySelectorAll('div, fieldset').forEach(function(el) {
      if (el.className && el.className.indexOf('mb-') === 0) return;
      el.style.setProperty('display', 'none', 'important');
    });
  }

  document.querySelectorAll('.mb-size').forEach(function(btn) {
    btn.addEventListener('click', function() {
      setTimeout(hideGloboElements, 50);
      setTimeout(hideGloboElements, 300);
    });
  });

  /* ── Lightbox ── */
  (function() {
    var lb        = document.getElementById('mb-lightbox-' + SECTION);
    var lbImg     = document.getElementById('mb-lb-img-' + SECTION);
    var lbStage   = document.getElementById('mb-lb-stage-' + SECTION);
    var lbClose   = document.getElementById('mb-lb-close-' + SECTION);
    var lbPrev    = document.getElementById('mb-lb-prev-' + SECTION);
    var lbNext    = document.getElementById('mb-lb-next-' + SECTION);
    var galleryMain = document.getElementById('mb-gallery-main-' + SECTION);
    if (!lb || !lbImg || !galleryMain) return;

    var allImgs = document.querySelectorAll('#mb-gallery-' + SECTION + ' .mb-gallery-img');
    var currentIdx = 0;
    var scale = 1;
    var panX = 0, panY = 0;
    var dragging = false, startX, startY, startPanX, startPanY;

    function getFullSrc(idx) {
      var imgs = document.querySelectorAll('#mb-gallery-' + SECTION + ' .mb-gallery-img');
      if (imgs[idx]) return imgs[idx].getAttribute('data-full') || imgs[idx].src;
      return '';
    }

    function openLightbox(idx) {
      currentIdx = idx;
      scale = 1; panX = 0; panY = 0;
      lbImg.src = getFullSrc(idx);
      applyTransform();
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
      updateArrows();
    }

    function closeLightbox() {
      lb.classList.remove('open');
      document.body.style.overflow = '';
      lbImg.src = '';
      scale = 1; panX = 0; panY = 0;
    }

    function applyTransform() {
      lbImg.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + scale + ')';
      lbImg.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
    }

    function updateArrows() {
      if (lbPrev) lbPrev.style.opacity = currentIdx === 0 ? '0.3' : '1';
      if (lbNext) lbNext.style.opacity = currentIdx >= allImgs.length - 1 ? '0.3' : '1';
    }

    /* Open on main image click */
    galleryMain.addEventListener('click', function() {
      var activeImg = galleryMain.querySelector('.mb-gallery-img:not(.is-hidden)');
      var idx = activeImg ? parseInt(activeImg.dataset.index) : 0;
      openLightbox(idx);
    });

    /* Close */
    lbClose.addEventListener('click', closeLightbox);
    lb.addEventListener('click', function(e) { if (e.target === lb || e.target === lbStage) closeLightbox(); });
    document.addEventListener('keydown', function(e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft' && currentIdx > 0) goTo(currentIdx - 1);
      if (e.key === 'ArrowRight' && currentIdx < allImgs.length - 1) goTo(currentIdx + 1);
    });

    /* Navigate */
    function goTo(idx) {
      currentIdx = idx;
      scale = 1; panX = 0; panY = 0;
      lbImg.src = getFullSrc(idx);
      applyTransform();
      updateArrows();
    }
    if (lbPrev) lbPrev.addEventListener('click', function(e) { e.stopPropagation(); if (currentIdx > 0) goTo(currentIdx - 1); });
    if (lbNext) lbNext.addEventListener('click', function(e) { e.stopPropagation(); if (currentIdx < allImgs.length - 1) goTo(currentIdx + 1); });

    /* Click to zoom toggle */
    lbImg.addEventListener('click', function(e) {
      e.stopPropagation();
      if (scale === 1) { scale = 2.5; } else { scale = 1; panX = 0; panY = 0; }
      applyTransform();
    });

    /* Scroll to zoom */
    lbStage.addEventListener('wheel', function(e) {
      e.preventDefault();
      scale = Math.min(5, Math.max(1, scale + (e.deltaY < 0 ? 0.3 : -0.3)));
      if (scale === 1) { panX = 0; panY = 0; }
      applyTransform();
    }, { passive: false });

    /* Drag to pan */
    lbImg.addEventListener('mousedown', function(e) {
      if (scale <= 1) return;
      dragging = true; startX = e.clientX; startY = e.clientY;
      startPanX = panX; startPanY = panY;
      lbImg.style.cursor = 'grabbing';
      e.preventDefault();
    });
    document.addEventListener('mousemove', function(e) {
      if (!dragging) return;
      panX = startPanX + (e.clientX - startX);
      panY = startPanY + (e.clientY - startY);
      applyTransform();
    });
    document.addEventListener('mouseup', function() {
      if (dragging) { dragging = false; lbImg.style.cursor = scale > 1 ? 'grab' : 'zoom-in'; }
    });

    /* Touch zoom/pan */
    var lastTouchDist = 0;
    lbStage.addEventListener('touchstart', function(e) {
      if (e.touches.length === 2) {
        lastTouchDist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
      } else if (e.touches.length === 1 && scale > 1) {
        dragging = true; startX = e.touches[0].clientX; startY = e.touches[0].clientY;
        startPanX = panX; startPanY = panY;
      }
    }, { passive: true });
    lbStage.addEventListener('touchmove', function(e) {
      if (e.touches.length === 2) {
        var dist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
        scale = Math.min(5, Math.max(1, scale * (dist / lastTouchDist)));
        lastTouchDist = dist;
        applyTransform();
        e.preventDefault();
      } else if (dragging && e.touches.length === 1) {
        panX = startPanX + (e.touches[0].clientX - startX);
        panY = startPanY + (e.touches[0].clientY - startY);
        applyTransform();
      }
    }, { passive: false });
    lbStage.addEventListener('touchend', function() { dragging = false; });
  })();

})();